// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectEntitiesMatchesEntitySportId,
  selectEntitiesMatchesEntitySrSeasonId,
  selectEntitiesMatchesEntitySrTournamentId,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectMatchTeamCompetitorId } from '../../selectors/match.selector';

const selectTournamentSrId = createSelector([selectEntitiesMatchesEntitySrTournamentId], (srTournamentId) =>
  srTournamentId ? parseInt(srTournamentId.replace('sr:tournament:', ''), 10) : undefined,
);

const selectSeasonSrId = createSelector([selectEntitiesMatchesEntitySrSeasonId], (srSeasonId) =>
  srSeasonId ? parseInt(srSeasonId.replace('sr:season:', ''), 10) : undefined,
);

const selectSportRadarPlayerWidgetProps = createSelector(
  [selectMatchTeamCompetitorId, selectTournamentSrId, selectSeasonSrId, selectEntitiesMatchesEntitySportId],
  (competitorId, tournamentSrId, seasonSrId, sportId) => ({
    teamSrId: competitorId,
    tournamentSrId,
    seasonSrId,
    sportId,
  }),
);

export default selectSportRadarPlayerWidgetProps;
